__turbopack_context__.v({
  "decorativeCaret": "nameQuizInput-module__ORTJMa__decorativeCaret",
  "nameQuizCaretBlink": "nameQuizInput-module__ORTJMa__nameQuizCaretBlink",
});
